import {
  createListenerMiddleware,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { apiWithAuth } from "./auth";
import { User, LoginResponse } from "../../types/interfaces";

export interface AuthState {
  isAuthenticated?: boolean;
  user?: User | null;
  accessToken?: string | null;
  refreshToken?: string | null;
}

const initialState: AuthState = {
  isAuthenticated: !!localStorage.getItem("accessToken"),
  user: null,
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenRefreshed: (
      state,
      action: PayloadAction<{ access: string; refresh: string }>,
    ) => {
      state.accessToken = action.payload.access;
      state.refreshToken = action.payload.refresh;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        apiWithAuth.endpoints.login.matchFulfilled,
        (state, action: PayloadAction<LoginResponse>) => {
          state.isAuthenticated = true;
          state.accessToken = action.payload.access;
          state.refreshToken = action.payload.refresh;
        },
      )

      .addMatcher(apiWithAuth.endpoints.checkAuth.matchFulfilled, (state) => {
        state.isAuthenticated = true;
      })
      .addMatcher(
        apiWithAuth.endpoints.resetPassword.matchFulfilled,
        (state) => {},
      )
      .addMatcher(apiWithAuth.endpoints.checkAuth.matchRejected, (state) => {
        state.isAuthenticated = false;
        state.accessToken = null;
      })
      .addMatcher(apiWithAuth.endpoints.logout.matchFulfilled, (state) => {
        state.isAuthenticated = false;
        state.user = null;
        state.accessToken = null;
        state.refreshToken = null;
      })
      .addMatcher(
        apiWithAuth.endpoints.getUser.matchFulfilled,
        (state, action: PayloadAction<User>) => {
          state.user = action.payload;
        },
      )
      .addMatcher(
        apiWithAuth.endpoints.confirmEmailVerification.matchFulfilled,
        (state, action: PayloadAction<{ message: string; email: string }>) => {
          if (state.user) {
            state.user.email = action.payload.email;
          }
        },
      );
  },
});

export const { tokenRefreshed, logout } = authSlice.actions;
export default authSlice.reducer;
